class TkStickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.targetButton = null;
    this.visibilityObserver = null;
    this.spinnerObserver = null;
    this.loadingTimeout = null;
  }

  connectedCallback() {
    this.targetButtonId = this.dataset.targetButtonId;
    this.targetButton = document.getElementById(this.targetButtonId);

    this.button = this.querySelector('.tk-sticky-add-to-cart__button');
    this.spinner = this.querySelector('.loading__spinner');
    this.button.addEventListener('click', this.handleClick.bind(this));

    if (!this.targetButton) return;

    this.visibilityObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.hidden = entry.isIntersecting;
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    );
    this.visibilityObserver.observe(this.targetButton);
  }

  disconnectedCallback() {
    if (this.visibilityObserver) this.visibilityObserver.disconnect();
    if (this.spinnerObserver) this.spinnerObserver.disconnect();
    if (this.loadingTimeout) clearTimeout(this.loadingTimeout);
  }

  setLoading(isLoading) {
    this.button.classList.toggle('loading', isLoading);
    this.button.disabled = isLoading;
    if (this.spinner) this.spinner.classList.toggle('hidden', !isLoading);
  }

  handleClick() {
    const freshTargetButton = document.getElementById(this.targetButtonId);
    if (!freshTargetButton || freshTargetButton.disabled) return;

    this.setLoading(true);

    if (this.loadingTimeout) clearTimeout(this.loadingTimeout);
    this.loadingTimeout = setTimeout(() => this.setLoading(false), 8000);

    if (this.spinnerObserver) this.spinnerObserver.disconnect();

    const realSpinner = freshTargetButton.querySelector('.loading__spinner');
    if (realSpinner) {
      this.spinnerObserver = new MutationObserver(() => {
        if (realSpinner.classList.contains('hidden')) {
          clearTimeout(this.loadingTimeout);
          this.setLoading(false);
          this.spinnerObserver.disconnect();
        }
      });
      this.spinnerObserver.observe(realSpinner, { attributes: true, attributeFilter: ['class'] });
    }

    freshTargetButton.click();
  }
}

customElements.define('tk-sticky-add-to-cart', TkStickyAddToCart);